import { AddressType } from "../../types/commonTypes/addressType";

// Address initial state
export const addressInitialState: AddressType = {
    address: "",
    additionalAddress: "",
    postalCode: "",
    city: "",
    cities: []
}